/**
 * src/components/directory-page/FeaturedFilters.js
 *
 * Barra de búsqueda + filtros de la sección destacados.
 * Props: {
 *   onSearch:   (term: string)   => void,
 *   onCategory: (slug: string)   => void,
 *   onOpen:     (only: boolean)  => void,
 *   onPromo:    (only: boolean)  => void,
 *   onSort:     (mode: string)   => void,
 *   categories: string[]
 * }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { uiIcons } from '@/shared/brandIcons.js'

define('FeaturedFilters', ({ onSearch, onCategory, onOpen, onPromo, onSort, categories = [], initialCategory = '' }) => {

    /* Búsqueda */
    const searchInput = h('input', {
        type: 'text',
        className: 'feat-filters__search-input',
        placeholder: 'Buscar negocio...'
    })
    searchInput.addEventListener('input', () => onSearch(searchInput.value.trim().toLowerCase()))

    const searchWrap = h('div', { className: 'feat-filters__search' },
        h('span', {}, '🔍'),
        searchInput
    )

    /* Selector categoría */
    const catOptions = [h('option', { value: '' }, 'Categoría')]
    categories.forEach(cat => {
        catOptions.push(h('option', { value: cat.slug }, cat.name))
    })
    const catSelect = h('select', { className: 'feat-filters__select' }, ...catOptions)
    if (initialCategory) catSelect.value = initialCategory
    catSelect.addEventListener('change', () => onCategory(catSelect.value))

    /* Abierto ahora */
    const openBtn = h('button', { className: 'feat-filters__chip', type: 'button' }, 'Abierto ahora')
    let openActive = false
    openBtn.addEventListener('click', () => {
        openActive = !openActive
        openBtn.classList.toggle('feat-filters__chip--active', openActive)
        onOpen(openActive)
    })

    /* Promociones */
    const promoBtn = h('button', { className: 'feat-filters__chip', type: 'button', innerHTML: uiIcons.gift + ' Promociones' })
    let promoActive = false
    promoBtn.addEventListener('click', () => {
        promoActive = !promoActive
        promoBtn.classList.toggle('feat-filters__chip--active', promoActive)
        onPromo(promoActive)
    })

    /* Ordenar */
    const sortSelect = h('select', { className: 'feat-filters__select' },
        h('option', { value: 'rating' }, 'Mejor valorados'),
        h('option', { value: 'name'   }, 'A-Z'),
        h('option', { value: 'reviews'}, 'Más reseñas')
    )
    sortSelect.addEventListener('change', () => onSort(sortSelect.value))

    return h('div', { className: 'feat-filters' },
        searchWrap,
        catSelect,
        openBtn,
        promoBtn,
        sortSelect
    )
})
